import './ForgetPassword.css'

import Heart from "../../App/Heart/Heart";
import ResetPasswordSend from "../ResetPasswordSend/ResetPasswordSend";
import {FormForgetPassword} from "./FormForgetPassword";
import Turnstile from "react-turnstile";
import React from "react";

class ForgetPassword extends Heart {
    default = ''
    constructor(props) {
        super(props);
        this.state = {
            alerts: '',
            captchaToken: null,
            captchaKey: Date.now(),
        }
    }
    render() {
        this.inputs = []
        return (
            <div className="MotdepasseOublier">
                <p className={"indication"}>Pour réinitialiser votre mot de passe, <br/>veuillez renseigner votre adresse mail :</p>
                <FormForgetPassword
                    refSubmit={this.refSubmit}
                    setAlert={(message, variant, dismissible) => this.setAlert(message, variant, dismissible)}
                    handleSubmit={(e) => this.handleSubmit(e)}
                    refForm={this}
                    alerts={this.state.alerts}
                />
                {process.env.REACT_APP_CLOUDFLARE_TURNSTILE_ACTIF === "true" && (
                  <div className="captcha-container text-center my-3">
                    <Turnstile
                      sitekey={process.env.REACT_APP_CLOUDFLARE_TURNSTILE_ACTIF_KEY}
                      options={{theme: 'dark', size: 'invisible', language: 'fr'}}
                      onVerify={(token) => {
                        this.setState({ captchaToken: token });
                      }}
                      onExpire={() => {
                        console.warn("Turnstile expiré");
                        this.setState({ captchaToken: null });
                      }}
                      onError={() => {
                        console.error("Erreur Turnstile");
                        this.setState({ captchaToken: null });
                      }}
                    />
                  </div>
                )}
                <p className={"retour"}>
                    <a
                        href={"/utilisateur/connexion"}
                        onClick={(e) => {
                            e.preventDefault()
                            /**
                             * TODO - METHODE A SUPPRIMER | VOIR POUR METTRE EN PLACE LE ROUTEUR SUR L'ENSEMBLE DU SITE
                             * **/
                            // this.handleNextComponent(<Connection Accueil={this.props.Accueil} App={this.props.App} />)
                            window.location.replace(window.location.origin);
                        }}
                        className={"text-black"}>
                        Retour
                    </a>
                </p>
            </div>
        );
    }
    handleSubmit(e) {

        e.preventDefault()

        /** Déclaration des variables */
        let email = document.getElementById('mail')

        if (process.env.REACT_APP_CLOUDFLARE_TURNSTILE_ACTIF==="true")
        {
            this.props.App.Utilisateur.CloudFlareTurnstile(this.state.captchaToken).then((data) => {
              if (data.success) {
                  this.props.App.Utilisateur.ForgetPassword(email.value).then(sortie => {
                      this.props.Accueil.switchContainer(
                          <ResetPasswordSend message={sortie.message} Accueil={this.props.Accueil} App={this.props.App} />
                      )
                  }, sortie => {
                      this.setAlert(sortie.message)
                      this.setState({
                        captchaToken: null,
                        captchaKey: Date.now()
                      });
                  })
              } else {
                  this.setAlert("Échec de la validation Cloudflare Turnstile.")
              }
            }).catch((err) => {
                this.setAlert(err.message || "Erreur lors de la vérification du captcha.");
            });
        } else {
            this.props.App.Utilisateur.ForgetPassword(email.value).then(sortie => {
                this.props.Accueil.switchContainer(
                    <ResetPasswordSend message={sortie.message} Accueil={this.props.Accueil} App={this.props.App} />
                )
            }, sortie => {
                this.setAlert(sortie.message)
            })
        }
    }
    handleFormChange() {
        this.handleFormChangeAll()
    }
}

export default ForgetPassword